export enum SuggestionVisibility {
  PRIVATE = 'PRIVATE',
  OPERATIONAL = 'OPERATIONAL',
  INSTITUTIONAL = 'INSTITUTIONAL',
  PASSENGERS = 'PASSENGERS',
  PUBLIC = 'PUBLIC',
}
